<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleDialogClose"
  >
    <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px" size="small">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="form.customerName" placeholder="请输入客户名称" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同编号" prop="contractNo">
            <el-input v-model="form.contractNo" placeholder="请输入合同编号" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="甲方" prop="partyA">
            <el-input v-model="form.partyA" placeholder="请输入甲方名称" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="乙方" prop="partyB">
            <el-input v-model="form.partyB" placeholder="请输入乙方名称" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同金额" prop="contractAmount">
            <el-input v-model="form.contractAmount" placeholder="请输入合同金额（万元）" type="number" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同状态" prop="contractStatusEnum">
            <el-select v-model="form.contractStatusEnum" placeholder="请选择" style="width: 100%;" :disabled="type === 'preview'">
              <el-option
                v-for="item in contractStatusList"
                :key="item.enumkey"
                :label="item.desc"
                :value="item.enumkey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签订日期" prop="signingDate">
            <el-date-picker :disabled="type === 'preview'"
              v-model="form.signingDate"
              type="date"
              placeholder="请选择签订日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费日期" prop="paymentDate">
            <el-date-picker :disabled="type === 'preview'"
              v-model="form.paymentDate"
              type="date"
              placeholder="请选择收费日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付方式" prop="paymentMethodEnum">
            <el-select v-model="form.paymentMethodEnum" placeholder="请选择" style="width: 100%;" :disabled="type === 'preview'">
              <el-option
                v-for="item in paymentMethodList"
                :key="item.enumkey"
                :label="item.desc"
                :value="item.enumkey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="缴费类型" prop="paymentTypeEnum">
            <el-select v-model="form.paymentTypeEnum" placeholder="请选择" style="width: 100%;" :disabled="type === 'preview'">
              <el-option
                v-for="item in paymentTypeList"
                :key="item.enumkey"
                :label="item.desc"
                :value="item.enumkey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="缴费凭证">
            <template v-if="type !== 'preview'">
              <el-upload :disabled="type === 'preview'"
                v-if="!voucherList.length"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="handleVoucherSuccess"
                :data="{ filePath: 'spbcn/spbcnappneed/crm/paymentVoucher/' }"
                :show-file-list="false"
              >
                <el-button size="small" type="primary" plain>点击上传</el-button>
              </el-upload>
              <el-upload :disabled="type === 'preview'"
                v-else
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="handleVoucherSuccess"
                :data="{ filePath: 'spbcn/spbcnappneed/crm/paymentVoucher/' }"
                :show-file-list="false"
                style="display: inline-block; margin-left: 8px;"
              >
                <el-button size="small" plain>重新上传</el-button>
              </el-upload>
            </template>
            <div v-if="voucherList.length">
              <div style="margin-left: 10px; margin-top: 10px;"
                v-for="(item, idx) in voucherList"
                :key="idx"
              >
                <el-tag type="" effect="plain" size="small"><i class="el-icon-paperclip"></i>缴费凭证</el-tag>
                <i class="el-icon-download icon-btn1" @click="downloadFile(item.url)"></i>
                <i class="el-icon-error icon-btn2" v-if="type === 'edit'" @click="removeVoucher(idx)"></i>
              </div>
            </div>
            <div class="default" v-if="type === 'preview' && !voucherList.length">暂未上传</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="合同附件">
            <template v-if="type !== 'preview'">
              <el-upload
                v-if="!attachmentList.length"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="handleAttachmentSuccess"
                :data="{ filePath: 'spbcn/spbcnappneed/crm/contractAttachment/' }"
                :show-file-list="false"
              >
                <el-button size="small" type="primary" plain>点击上传</el-button>
              </el-upload>
              <el-upload
                v-else
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="handleAttachmentSuccess"
                :data="{ filePath: 'spbcn/spbcnappneed/crm/contractAttachment/' }"
                :show-file-list="false"
                style="display: inline-block; margin-left: 8px;"
              >
                <el-button size="small" plain>重新上传</el-button>
              </el-upload>
            </template>
            <div v-if="attachmentList.length">
              <div style="margin-left: 10px; margin-top: 10px;"
                v-for="(item, idx) in attachmentList"
                :key="idx"
              >
                <el-tag type="" effect="plain" size="small"><i class="el-icon-paperclip"></i>合同附件</el-tag>
                <i class="el-icon-download icon-btn1" @click="downloadFile(item.url)"></i>
                <i class="el-icon-error icon-btn2" v-if="type === 'edit'" @click="removeAttachment(idx)"></i>
              </div>
            </div>
            <div class="default" v-if="type === 'preview' && !attachmentList.length">暂未上传</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="提交审批" prop="submitProcess" :disabled="type === 'preview'">
            <el-radio-group v-model="form.submitProcess">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息" :disabled="type === 'preview'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" v-if="type === 'edit'">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 编辑时传入行数据，新增时传 null
    row: {
      type: Object,
      default: null
    },
    // 项目类型（新增时用）
    projectType: {
      type: String,
      default: ''
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      form: {
        id: null,
        customerName: '',
        partyA: '',
        partyB: '',
        contractAmount: '',
        contractNo: '',
        contractStatusEnum: '',
        projectTypeEnum: '',
        signingDate: '',
        paymentDate: '',
        paymentMethodEnum: '',
        paymentTypeEnum: '',
        paymentVoucher: '',
        contractAttachment: '',
        submitProcess: true,
        remark: ''
      },
      formRules: {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        partyA: [{ required: true, message: '请输入甲方', trigger: 'blur' }],
        partyB: [{ required: true, message: '请输入乙方', trigger: 'blur' }],
        contractAmount: [{ required: true, message: '请输入合同金额', trigger: 'blur' }],
        contractNo: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
        contractStatusEnum: [{ required: true, message: '请选择合同状态', trigger: 'change' }],
        signingDate: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        paymentDate: [{ required: true, message: '请选择收费日期', trigger: 'change' }],
        paymentMethodEnum: [{ required: true, message: '请选择支付方式', trigger: 'change' }],
        paymentTypeEnum: [{ required: true, message: '请选择缴费类型', trigger: 'change' }],
        submitProcess: [{ required: true, message: '请选择是否提交审批', trigger: 'change' }]
      },
      contractStatusList: [],
      paymentMethodList: [],
      paymentTypeList: [],
      uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
      uploadHeaders: { Authorization: localStorage.getItem('Authorization') },
      voucherList: [],
      attachmentList: [],
      submitLoading: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible },
      set (val) { this.$emit('update:visible', val) }
    },
    dialogTitle () {
      return this.row && this.row.id ? '编辑合同' : '新增合同'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.getSelectList()
        if (this.row && this.row.id) {
          this.fillForm(this.row)
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    getSelectList () {
      if (this.contractStatusList.length > 0) return
      this.$http.get('contractPaymentInfo/enums').then(res => {
        if (res.code === 200) {
          this.contractStatusList = res.data.contractStatusList || []
          this.paymentMethodList = res.data.paymentMethodList || []
          this.paymentTypeList = res.data.paymentTypeList || []
        }
      })
    },
    // 填充表单（编辑时）
    fillForm (row) {
      Object.keys(this.form).forEach(key => {
        if (row[key] !== undefined && row[key] !== null) {
          this.form[key] = row[key]
        }
      })
      // 回填上传文件列表（URL 可能已带域名）
      this.voucherList = this.form.paymentVoucher
        ? [{ name: '缴费凭证', url: this.form.paymentVoucher }]
        : []
      this.attachmentList = this.form.contractAttachment
        ? [{ name: '合同附件', url: this.form.contractAttachment }]
        : []
    },
    resetForm () {
      this.form = {
        id: null,
        customerName: '',
        partyA: '',
        partyB: '',
        contractAmount: '',
        contractNo: '',
        contractStatusEnum: '',
        projectTypeEnum: '',
        signingDate: '',
        paymentDate: '',
        paymentMethodEnum: '',
        paymentTypeEnum: '',
        paymentVoucher: '',
        contractAttachment: '',
        submitProcess: true,
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields()
      })
      this.voucherList = []
      this.attachmentList = []
    },
    handleDialogClose () {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    onSubmit () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const params = { ...this.form }
        // 新增时带上项目类型
        if (!params.id) {
          params.projectTypeEnum = this.projectType
        }
        // 编辑时 URL 保持 add（后端按 id 判断新增或更新）
        const url = params.id ? 'contractPaymentInfo/update' : 'contractPaymentInfo/add'
        this.$http.post(url, params).then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.$emit('success')
          }
          this.submitLoading = false
        })
      })
    },
    handleVoucherSuccess (res) {
      if (res.code === 200 && res.data) {
        this.form.paymentVoucher = res.data
        this.voucherList = [{ name: this.getFileName(res.data), url: res.data }]
      }
    },
    removeVoucher (idx) {
      this.voucherList.splice(idx, 1)
      this.form.paymentVoucher = ''
    },
    handleAttachmentSuccess (res) {
      if (res.code === 200 && res.data) {
        this.form.contractAttachment = res.data
        this.attachmentList = [{ name: this.getFileName(res.data), url: res.data }]
      }
    },
    removeAttachment (idx) {
      this.attachmentList.splice(idx, 1)
      this.form.contractAttachment = ''
    },
    getFileName (url) {
      if (!url) return ''
      return decodeURIComponent(url.split('/').pop())
    },
    downloadFile (url) {
      if (!url) return
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.download = ''
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>
<style lang="less" scoped>
.icon-btn1{
  font-size: 16px;
  color: #4096ff;
  margin-left: 10px;
  cursor: pointer;
}
.icon-btn2{
  font-size: 16px;
  color: #F56C6C;
  margin-left: 10px;
  cursor: pointer;
}
.default{
  font-size: 12px;
  color: #999;
}
</style>
